<template>
<el-dialog :visible="visible" :title="isEdit ? $t('编辑账户') : $t('新增账户')" :close-on-click-modal="false" @close="handleClose" width="640px">
    <div class="account-container" v-loading="loading">
      <el-form ref="formRef" :show-message="false" :model="formData" :rules="formRule" label-position="top" size="mini">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('账号')" prop="userAccountName">
              <el-input v-model="formData.userAccountName" :placeholder="$t('请输入账号')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isEdit">
            <el-form-item :label="$t('密码')" prop="userPwd">
              <el-input v-model="formData.userPwd" :placeholder="$t('请输入密码')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('姓名')" prop="userName">
              <el-input v-model="formData.userName" :placeholder="$t('请输入姓名')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('电话')">
              <el-input v-model="formData.mobile" :placeholder="$t('请输入电话')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('邮箱')">
              <el-input v-model="formData.email" :placeholder="$t('请输入邮箱')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('酒店')" prop="hotelVids">
              <el-select v-model="formData.hotelVids" multiple :placeholder="$t('请选择酒店')" style="width: 100%" class="hotel-select" @change="handleHotelChange">
                <el-option v-for="item in hotelOptions" :key="item.hotelVid" :label="item.hotelName" :value="item.hotelVid"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('状态')">
              <el-switch v-model="formData.state"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item class="is-required" :label="$t('角色')" prop="role">
              <OrgRole ref="OrgRoleRef" v-model:role="formData.role"></OrgRole>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <template #footer>
      <div>
        <el-button @click="handleClose">{{$t('取消')}}</el-button>
        <el-button type="primary" @click="handleConfirm">{{$t('确定')}}</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { intl } from "@tci18n/vue2";import _ from 'lodash';
import memberAPI from '@/view/organization/api/member';
import commonApi from '@/view/common/api';
import OrgRole from './role.vue';
import cacheHelper from '@/view/common/cache';

/**
 * 角色操作组件
 * 角色组件，使用v-model双向绑定数据, 通过v-model:role="formData.role"传递数据
 * 因为 roleOperate 组件是一个独立的组件，它是一个formItem里的一个表单项，所以需要通过v-model传递数据
 * 因为使用v-model传递数据，所以需要在组件内部使用model属性，所以编辑时，用ref的set方法去初始化值。这样bian
 * 我在考虑是不是要使用provide/inject来传递数据
 */
export default {
  name: 'OrgAccount', // 组件名称

  components: {
    OrgRole
  },

  provide() {
    return {
      OrgAccount: this
    };
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: () => {}
    }
  },

  model: {
    prop: 'visible',
    event: 'update:visible'
  },

  data() {
    return {
      formData: {
        userAccountName: '',
        userPwd: '',
        userName: '',
        mobile: '',
        email: '',
        state: true,
        hotelVids: [],
        role: {
          roleIds: [],
          hotelRoleList: []
        }
      },
      hotelOptions: [],
      formRule: {
        userAccountName: [{ required: true, message: intl.$t("请输入账号"), trigger: 'change' }],
        userPwd: [{ required: true, message: intl.$t("请输入密码"), trigger: 'change' }],
        userName: [{ required: true, message: intl.$t("请输入姓名"), trigger: 'change' }],
        hotelVids: [
        {
          required: true,
          message: intl.$t("请选择酒店"),
          trigger: 'change'
        }],

        role: [
        {
          validator: (rule, value, callback) => {
            if (value && (value.roleIds && value.roleIds.length > 0 || value.hotelRoleList && value.hotelRoleList.length > 0)) {
              callback();
            } else {
              callback(new Error(intl.$t("请至少选择一个角色")));
            }
          },
          message: intl.$t("请至少选择一个角色"),
          trigger: 'change'
        }]

      },
      loading: false
    };
  },
  computed: {
    isEdit() {
      //如果填充了数据了，就说明需要编辑数据
      return !!(this.detail && this.detail.userId && `${this.detail.userId}`.length > 0);
    }
  },

  watch: {
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          this.getHotelOptions();
          if (this.$refs['OrgRoleRef'] && this.$refs['OrgRoleRef'].getHotelList) {
            this.$refs['OrgRoleRef'].getHotelList().then(() => {
              if (this.isEdit) {
                this.getDetail();
              } else {
                this.handleResrtFields();
              }
            });
          } else {
            this.$nextTick(() => {
              if (this.isEdit) {
                this.getDetail();
              } else {
                this.handleResrtFields();
              }
            });
          }
        });
      }
    }
  },

  methods: {
    handleClose() {
      this.$emit('update:visible', false);
    },

    // 处理酒店选择变化
    handleHotelChange(val) {
      if (!val || val.length === 0) return;

      const hasAllHotel = val.includes('');

      if (hasAllHotel) {
        // 如果选择了"全部酒店"，则只保留这一项
        this.formData.hotelVids = [''];
      } else {
        // 如果没有选择"全部酒店"，确保不包含它
        this.formData.hotelVids = val.filter((vid) => vid !== '');
      }
    },

    handleConfirm() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          let params = {
            userId: this.isEdit ? this.formData.userId || '' : '',
            email: this.formData.email || '',
            mobile: this.formData.mobile || '',
            state: this.formData.state ? 1 : 0,
            userAccountName: this.formData.userAccountName || '',
            userName: this.formData.userName || '',
            userPwd: this.formData.userPwd || '',
            hotelVids: (this.formData.hotelVids || []).join(','),
            // blocRoleIds:this.formData.role.roleIds || [],
            userHotelRoleList: _.clone(this.formData.role.hotelRoleList || [])
          };
          //   console.log(params)
          if (this.formData.role.roleIds && this.formData.role.roleIds.length > 0) {
            params.userHotelRoleList.push({
              hotelVid: 0,
              roleIds: this.formData.role.roleIds
            });
          }
          //   console.log('params', params)
          memberAPI.
          memberSave(params).
          then((res) => {
            if (res.code == 200) {
              this.$emit('update:visible', false);
              this.$emit('submit:success');

              this.handleResrtFields();
            } else {
              this.$notice.error(res.message);
            }
          }).
          catch((error) => {
            this.$notice.error(error.message || intl.$t("系统异常，请稍后再试"));
            console.error('Save member error: ', error.message);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    handleResrtFields() {
      if (this.$refs['OrgRoleRef'] && this.$refs['OrgRoleRef'].setRoleData) {
        this.$refs['OrgRoleRef'].setRoleData({
          roleIds: [],
          hotelRoleList: []
        });
      }
      this.formData.hotelVids = [];
      this.$nextTick(() => {
        this.$refs['formRef'].resetFields();
      });
    },

    getHotelOptions() {
      // 获取当前登录用户信息
      const currentUser = cacheHelper.getLocalCachedUserInfo();
      const currentUserId = currentUser && currentUser.userId;

      commonApi.hotelListByName().then((hotelRes) => {
        let hotelList = hotelRes.code == 200 && hotelRes.data ? hotelRes.data : [];

        // 过滤掉 hotelVid=0 的项
        hotelList = _.filter(hotelList, (it) => it.hotelVid !== '0' && it.hotelVid !== 0);

        // 调用 memberInfo 获取当前登录用户的 hotelVids
        memberAPI.memberInfo({ id: currentUserId }).then((memberRes) => {
          if (memberRes.code == 200 && memberRes.data) {
            const hotelVids = memberRes.data.hotelVids;

            if (!hotelVids || hotelVids === '') {
              // hotelVids 为空或空字符时，按原逻辑赋值，再插入一个值为空字符串，文本为全部酒店的项
              this.hotelOptions = _.filter(hotelList, (it) => it.hotelVid != '');
              this.hotelOptions.unshift({ hotelVid: '', hotelName: intl.$t("全部酒店") });
            } else {
              // hotelVids 不为空时，按","分隔字符串，把得到的hotelVid集合和hotelList取交集
              const userHotelVids = hotelVids.split(',').filter((vid) => vid && vid !== '');
              this.hotelOptions = _.filter(hotelList, (it) => userHotelVids.includes(it.hotelVid));
            }
          }
        }).catch((err) => {
          console.error('获取当前用户信息失败', err);
        });
      }).catch((err) => {
        console.error('获取酒店列表失败', err);
        this.hotelOptions = [];
      });
    },

    // 获取编辑数据的详细信息
    getDetail() {
      if (!this.isEdit) return;
      try {
        this.loading = true;
        memberAPI.
        memberInfo({ id: this.detail.userId }).
        then((res) => {
          if (res.code == 200 && res.data && res.data.userId) {
            this.setEditData(_.cloneDeep(res.data));
          } else {
            this.$notice.error(res.message);
          }
        }).
        catch((err) => {
          console.error('获取编辑数据详细信息失败', err);
          this.$emit('update:visible', false);
        }).
        finally(() => {
          this.loading = false;
        });
      } catch (err) {
        console.error('获取编辑数据详细信息失败', err);
        this.$emit('update:visible', false);
      }
    },

    setEditData(data) {
      this.formData.userId = data.userId;
      this.formData.userAccountName = data.accountUserName || '';
      this.formData.userName = data.userName || '';
      this.formData.mobile = data.mobile || '';
      this.formData.email = data.email || '';
      this.formData.state = data.state == 1;
      // 初始化酒店下拉框，从hotelVids字符串中解析
      if (!data.hotelVids || data.hotelVids === '') {
        // hotelVids为空或空字符串时，默认选中"全部酒店"
        this.formData.hotelVids = [''];
      } else {
        const hotelVidArray = data.hotelVids.split(',').filter((vid) => vid);
        // 如果包含"全部酒店"(vid为空字符串)，则只选中"全部酒店"
        if (hotelVidArray.includes('')) {
          this.formData.hotelVids = [''];
        } else {
          this.formData.hotelVids = hotelVidArray;
        }
      }
      const groupRoleObj = _.find(data.hotelList || [], (it) => it.hotelVid == '0');
      let roleObj = {
        roleIds: [],
        hotelRoleList: []
      };
      roleObj.roleIds = _.uniq(groupRoleObj && groupRoleObj.roleList ? groupRoleObj.roleList.map((it) => it.id) : []);
      roleObj.hotelRoleList = _.uniqBy(
        _.filter(data.hotelList || [], (it) => it.hotelVid != '0').map((it) => {
          return {
            hotelVid: it.hotelVid,
            roleIds: _.uniq(it.roleList.map((it) => it.id))
          };
        }),
        'hotelVid'
      );

      this.formData.role = _.clone(roleObj);
      this.$refs['OrgRoleRef'].setRoleData(_.clone(roleObj));
    }
  }
};
</script>

<style lang="scss" scoped>
.account-container {
  margin-top: -20px;
  margin-bottom: -20px;
  :deep(.el-form--label-top .el-form-item__label) {
    padding-bottom: 4px;
  }
  :deep(.el-form-item) {
    margin-bottom: 8px;
  }
  :deep(.hotel-select .el-select__placeholder) {
    color: #606266 !important;
    opacity: 1 !important;
  }
}
</style>
